import { filter, map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../auth/actionAuth";
import { actionShopShiftLevelReceived, TypeActionShop } from "../actionShop";
/**
 * This epic listens for <code>TypeActionAuth.Login</code> and not <code>TypeActionShop.RequestUpdate</code>,
 * because we don't want it to re-request the shift level data during same session, when offers expire.
 * @param action$
 * @param state$
 * @param deps
 */
export var epicShopUpdateShiftLevel = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionAuth.Login ||
            action.type === TypeActionShop.RequestShiftLevelUpdate;
    }), switchMap(function (action) {
        var playerId = action.playerId ? action.playerId : state$.value.playerInfo.playerId;
        return deps.netSend({
            id: CommandCode.ShiftLevelInfo,
            props: {
                playerId: playerId,
            },
        });
    }), retry(), map(function (res) { return actionShopShiftLevelReceived(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epics/epicShopUpdateShiftLevel.ts
// module id = 2344
// module chunks = 3